import React from 'react'
import { useTranslation } from 'react-i18next'
import { displayPrice } from 'helpers'
import {
  getMembershipCardBgByTier,
  getMembershipNameByTier,
  getPointAlmostExpired,
  MEMBERSHIP_TIER,
} from 'helpers/membership'
import MembershipPrivilege from 'components/dine-in/MembershipPrivilege'
import dayjs from 'dayjs'
import { CurrentMembershipQuery } from 'graphQL/hatostore/generate/operations'

type MembershipPrivilegeSectionProps = {
  currentMembership: CurrentMembershipQuery['currentMembership']
  profileImage: string
  onClickPrivilegeButton: VoidFunction
}

const MembershipPrivilegeSection = ({
  currentMembership,
  profileImage,
  onClickPrivilegeButton,
}: MembershipPrivilegeSectionProps) => {
  const { firstName, memberTier, totalPoints, pointExpirations } = currentMembership
  const { t } = useTranslation()

  const getPrivilegeInfo = () => {
    const defaultInfo = t('dineIn.privilege.footerText')
    const pointExpiration = getPointAlmostExpired(pointExpirations)

    if (!pointExpiration) return defaultInfo

    const { points, expirationDate } = pointExpiration
    const expirationDateFormatted = dayjs(expirationDate).format('DD/MM/YY')
    return t('dineIn.privilege.pointsExpiration', { points: displayPrice(points), date: expirationDateFormatted })
  }

  const title = `${t('dineIn.privilege.prefixTitle')} ${firstName}`
  const totalPointsWithComma = displayPrice(totalPoints)
  const tierName = getMembershipNameByTier(memberTier as MEMBERSHIP_TIER)
  const description = `${tierName} : ${totalPointsWithComma} ${t('dineIn.privilege.point')}`
  const privilegeInfo = getPrivilegeInfo()

  return (
    <MembershipPrivilege
      title={title}
      profileImage={profileImage || '/assets/dine-in/avatar.png'}
      tierImageCard={getMembershipCardBgByTier(memberTier as MEMBERSHIP_TIER)}
      description={description}
      privilegeInfo={privilegeInfo}
      onClickPrivilegeButton={onClickPrivilegeButton}
    />
  )
}

export default MembershipPrivilegeSection
